import { useMutation, useQueryClient } from '@tanstack/react-query';
import { API_SERVICE, API_KEYS } from '../api';
import { useShowToast } from '@/hooks';
import { getRequisitionErrorMessage } from '../utils/requisitionErrorHandler';

interface UpdateRecruiterParams {
  requisitionId: string;
  recruiterId: number;
  needsReapproval?: boolean;
  reapprovalNote?: string;
  applyToGroup?: boolean;
}

export const useUpdateRequisitionRecruiter = () => {
  const queryClient = useQueryClient();
  const toast = useShowToast();

  return useMutation({
    mutationFn: ({
      requisitionId,
      recruiterId,
      needsReapproval,
      reapprovalNote,
      applyToGroup,
    }: UpdateRecruiterParams) => {
      const payload: any = {
        recruiter_id: recruiterId,
      };

      // Add reapproval fields if needed
      if (needsReapproval) {
        payload.need_reapproval = true;
        payload.reapproval_note = reapprovalNote;
      }

      // Add apply_to_group if needed
      if (applyToGroup) {
        payload.apply_to_group = true;
      }

      return API_SERVICE.updateRequisitionRecruiter(requisitionId, payload);
    },

    onSuccess: (_, { requisitionId }) => {
      queryClient.invalidateQueries({
        queryKey: [API_KEYS.getRequisition, requisitionId.toString()],
      });
      queryClient.invalidateQueries({
        queryKey: [API_KEYS.getRequisitions],
      });

      toast({
        title: 'Recruitment partner updated successfully',
      });
    },

    onError: (error: any) => {
      const errorMessage = getRequisitionErrorMessage(error, false);
      toast({
        title: 'Failed to update recruitment partner',
        description: errorMessage || 'Please try again',
        status: 'error',
      });
    },
  });
};
